import { $e } from '@/utils/Translate.js';

export class CONSTANT_STATUS {
  static status_dock = {
    0:  $e("Standby"),
    1:  $e("Débogage sur site"),
    2:  $e("Débogage à distance"),
    3:  $e("Mise à niveau du logiciel"),
    4:  $e("En fonctionnement"),
    5:  $e("À calibrer"),
    14: $e("Déconnecter"),
  }

  static status_drone = {
    0     : $e("Standby"),
    1     : $e("Préparation au décollage"),
    2     : $e("Fin de la préparation au décollage"),
    3     : $e("Vol manuel"),
    4     : $e("Décollage automatique"),
    5     : $e("Vol en ligne"),
    6     : $e("Prise de vue panoramique"),
    7     : $e("Suivi intelligent"),
    8     : $e("Évitement ADS-B"),
    9     : $e("Retour automatique"),
    10    : $e("Atterrissage automatique"),
    11    : $e("Atterrissage forcé"),
    12    : $e("Atterrissage à trois pales"),
    13    : $e("Mise à niveau"),
    14    : $e("Pas de connexion"),
    15    : $e("Système avancé d'aide au pilotage - APAS"),
    16    : $e("Pilotage virtuel"),
    17    : $e("Commandes de vol en court d'execution"),
    18    : $e("Airborne RTK fixing mode"),
    19    : $e("Dock address selecting"),
    20    : $e("POI"),
  }

  static status_flight = {
    paused        : $e("En pause"),
    failed        : $e("Échoué"),
    in_progress   : $e("En cours"),
    ok            : $e("Terminé"),
    null          : $e("Initialition")
  }

  static status_flight_etapes = {
    null        : $e("Initial state"),
    0           : $e("Initial state"),
    1           : $e("Vérification avant le lancement 1 : Le drone exécute-t-il un vol ?"),
    2           : $e("Vérification avant le lancement 2 : L'aéroport quitte-t-il le mode travail ?"),
    3           : $e("Vérification avant le lancement 3 : Exécution de l'itinéraire en cours"),
    4           : $e("Vérification avant le lancement 4 : Retour en cours"),
    5           : $e("L'exécution de l'itinéraire entre dans l'état de préparation), en attendant le début de l'émission de la tâche."),
    6           : $e("Entrée en service de l'aéroport"),
    7           : $e("Préparation du contrôle de démarrage de l'entrée et de l'ouverture des écoutilles"),
    8           : $e("Attente de l'état de préparation du système de vol), établissement de la connexion par poussée"),
    9           : $e("En attente d'une surveillance de la source RTK avec des valeurs rapportées"),
    10          : $e("Vérifier si la source RTK provient de l'aéroport ; si ce n'est pas le cas), réinitialiser."),
    11          : $e("Attente de la notification du contrôle de vol"),
    12          : $e("L'aéroport n'a pas de contrôle ; arracher le contrôle au drone"),
    13          : $e("Obtention de l'URL KMZ la plus récente"),
    14          : $e("Téléchargement KMZ"),
    15          : $e("Chargement KMZ terminer"),
    16          : $e("Configuration des couleurs"),
    17          : $e("Paramètres de décollage de l'avion), points d'atterrissage de dégagement), altitude de décollage), couleurs."),
    18          : $e("Paramètres de décollage « flyto » du drone"),
    19          : $e("Paramètres du point Home"),
    20          : $e("Déclencher l'exécution d'un itinéraire"),
    21          : $e("Exécution d'un itinéraire en cours"),
    22          : $e("Préparation des vérifications de retour"),
    23          : $e("Atterrissage du drone sur le dock"),
    24          : $e("Fermeture des portes après l'atterrissage"),
    25          : $e("Le dock quitte le mode de travail"),
    26          : $e("Recouvrement des anomalies dans le dock"),
    27          : $e("Chargement des journaux de bord du système de vol"),
    28          : $e("Vérification de l'état de l'enregistrement de la caméra"),
    29          : $e("Obtenir le nombre de fichiers multimédias"),
    30          : $e("Récupération anormale de l'ouverture de la trappe de décollage du dock"),
    31          : $e("Notifier les résultats des tâches"),
    32          : $e("Exécution de la tâche terminée ; lancement ou non de l'extraction du journal sur la base du fichier de configuration"),
    33          : $e("Récupération de la liste des journaux - Liste des aéronefs"),
    34          : $e("Récupération de la liste des journaux - Récupération de la liste des aéroports"),
    35          : $e("Log list retrieval - Upload log list results"),
    36          : $e("Récupération de journaux - Récupérer les journaux d'aéronefs "),
    37          : $e("Récupération des journaux - Récupération des journaux d'aéroport "),
    38          : $e("Récupération des journaux - Compression des journaux d'aéronefs "),
    39          : $e("Récupération des journaux - Compression des journaux d'aéroport"),
    40          : $e("Récupération des journaux - Téléchargement des journaux d'aéronefs"),
    41          : $e("Récupération des journaux - Téléchargement des journaux d'aéronefs"),
    42          : $e("Récupération des journaux - Notification des resulats"),
    '0xFFFD'    : $e("Attente de la réponse du service après achèvement"),
    '0xFFFE'    : $e("Pas de statut spécifique),0xFFFFF")
  }

  static status_flight_mission = {
    "-9"    : $e("Terminée (erreur)"),
    "0"     : $e("Init"),
    "1"     : $e("En attente d'execution"),
    "2"     : $e("En cours"),
    "3"     : $e("Email envoyé"),
    "4"     : $e("Vol annulé"),
    "9"     : $e("Terminée avec succès")
  }


  /** -------------------------- */

  static get(){
    return {
      status_dock: this.status_dock,
      status_drone: this.status_drone,
      status_flight: this.status_flight,
      status_flight_etapes: this.status_flight_etapes,
      status_flight_mission: this.status_flight_mission
    }
  }
}
